/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  EVENT_ENTRY_INVENTORY,
  EVENT_EXIT_INVENTORY,
  EVENT_INTERVENTION
} from '../../enums/CalendarEvents.mjs'
import { getInterventionLink } from '../../lib/links/interventionLinks'
import { getLeaseLink } from '../../lib/links/leaseLinks'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import { Badge, Button, Group, HoverCard, HoverCardProps, Stack, Text } from '@mantine/core'

export type CalendarEventHoverCardProps = HoverCardProps & {
  event: CalendarEvent
}

function CalendarEventHoverCard (props: CalendarEventHoverCardProps) {
  const { children, event, ...others } = props
  const intl = useIntl()
  return (
    <HoverCard
      openDelay={200}
      closeDelay={200}
      {...others}
      key={event.label}
    >
      <HoverCard.Target>
        {children}
      </HoverCard.Target>

      <HoverCard.Dropdown maw={400}>
        <Stack>
          <Group wrap="nowrap">
            <Badge circle color={event.color} />
            <Text fw="bold">
              {event.label}
            </Text>
          </Group>

          {event.date != null
            ? <Text size="sm" c="dimmed" tt="capitalize">
              {intl.formatDate(event.date, { dateStyle: 'full' })}
            </Text>
            : null}

          {event.description != null
            ? <Text>
              {event.description}
            </Text>
            : null}

          {event.type === EVENT_ENTRY_INVENTORY
            ? <Text>
              {intl.formatMessage({
                id: 'entry_inventory',
                defaultMessage: 'État des lieux d\'entrée'
              })}
            </Text>
            : null}

          {event.type === EVENT_EXIT_INVENTORY
            ? <Text>
              {intl.formatMessage({
                id: 'exit_inventory',
                defaultMessage: 'État des lieux de sortie'
              })}
            </Text>
            : null}

          {event.type === EVENT_INTERVENTION
            ? <Button
              component={AnchorLink}
              to={getInterventionLink(event.data.id)}
            >
              {intl.formatMessage({
                id: 'show',
                defaultMessage: 'Afficher'
              })}
            </Button>
            : null}

          {event.type === EVENT_ENTRY_INVENTORY || event.type ===
          EVENT_EXIT_INVENTORY
            ? <Button
              component={AnchorLink}
              to={getLeaseLink(event.data.id)}
            >
              {intl.formatMessage({
                id: 'show',
                defaultMessage: 'Afficher'
              })}
            </Button>
            : null}
        </Stack>
      </HoverCard.Dropdown>
    </HoverCard>
  )
}

export default CalendarEventHoverCard
